/* tslint:disable */

/**
 */
export class ViewReportHtml {
    content?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-report-html.ts